import { StrapiSpecialOrdersType } from "~/types/strapi";

export const SpecialOrdersTypes: Record<StrapiSpecialOrdersType, string> = {
  [StrapiSpecialOrdersType.tapes]: "tapes",
  [StrapiSpecialOrdersType.corrugatedBoxes]: "corrugated_box",
  [StrapiSpecialOrdersType.boxes]: "box",
  [StrapiSpecialOrdersType.plasticBagsWithHandles]: "plastic_bag",
  [StrapiSpecialOrdersType.plasticBagsForPackaging]: "packing_plastic_bag",
  [StrapiSpecialOrdersType.filmTapes]: "plastic_tape",
  [StrapiSpecialOrdersType.paperBagsWithHandles]: "paper_bag",
  [StrapiSpecialOrdersType.packagingPaperBags]: "packing_paper_bag",
  [StrapiSpecialOrdersType.bagsOfDifferentMaterials]: "other_bag",
  [StrapiSpecialOrdersType.plasticDishes]: "tableware",
  [StrapiSpecialOrdersType.labels]: "label",
  [StrapiSpecialOrdersType.multiLayerBags]: "multilayer_bag",
  [StrapiSpecialOrdersType.otherSpecialOrders]: "other_special_order",
};
